module.exports = __webpack_public_path__ + "static/media/ic-batch.104d7785.svg";